import React, { useContext, useEffect, useState } from "react";
import { DataTable } from "@MASTER";
import useLogics from "./logics";
import { UserContext, DrawerContext } from "@CONTEXTS";
import { Space, Dropdown, Menu } from "antd";
import { AiOutlinePlus } from "react-icons/ai";
import { getAdminUser } from "@ADMIN";

const Table = ({ setAddType }) => {
  const [adminUser, setAdminUser] = useState(null);
  const { data, loading, mutate } = useContext(UserContext);
  const { setDrawer } = useContext(DrawerContext);
  useEffect(() => {
    const fetchAdminUser = async () => {
      const admin = await getAdminUser();
      setAdminUser(admin);
    };

    fetchAdminUser();
  }, []);
  const logics = useLogics({ adminUser, setAddType });

  const menu = (
    <Menu
      onClick={({ key }) => {
        if (key === "1") {
          setAddType("multiple");
          setDrawer(true);
        }
      }}
    >
      <Menu.Item key="1" icon={<AiOutlinePlus />}>
        Toplu kullanıcı ekle
      </Menu.Item>
    </Menu>
  );

  return (
    <>
      <div style={{ float: "right" }}>
        <Space>
          <Dropdown.Button
            overlay={menu}
            onClick={() => {
              setAddType("single");
              setDrawer(true);
            }}
            type="primary"
          >
            Yeni Kullanıcı Ekle
          </Dropdown.Button>
        </Space>
      </div>

      {adminUser && (
        <DataTable
          name="Kullanıcı Listesi"
          {...logics}
          dataSource={data}
          rowKey="id"
          loading={loading}
          mutate={() => mutate()}
          pagination={false}
        />
      )}
    </>
  );
};

export default Table;
